module.exports = __webpack_public_path__ + "assets/img/a337607e-71c5-46b2-87cf-9e2d29600ba5.bbe9c748.jpg";